
import { Paella, utils, addDictionary, setLanguage, Events, defaultLoadConfigFunction } from 'paella-core';

import getBasicPluginContext from 'paella-basic-plugins';
import getSlidePluginContext from 'paella-slide-plugins';
import getZoomPluginContext from 'paella-zoom-plugin';

// import { addDictionary, setLanguage } from 'paella-core';

import packageData from "../package.json";

// Customized icons
import windowedIcon from "./icons/windowedIcon.svg";
import fullscreenIcon from "./icons/fullscreenIcon.svg";
import volumeHighIcon from "./icons/volumeHighIcon.svg";
import volumeMidIcon from "./icons/volumeMidIcon.svg";
import volumeLowIcon from "./icons/volumeLowIcon.svg";
import volumeMuteIcon from "./icons/volumeMuteIcon.svg";
import screenIcon from "./icons/screenIcon.svg";
import layoutIcon from "./icons/layoutIcon.svg";
/*import backwardIcon from "./icons/backwardIcon.svg";
import forwardIcon from "./icons/forwardIcon.svg";
import keyboardIcon from "./icons/keyboardIcon.svg";*/
import downloadIcon from "./icons/downloadIcon.svg";
import captionsIcon from "./icons/captionsIcon.svg";
import findCaptionsIcon from './icons/findCaptionsIcon.svg';
import slidesIcon from './icons/slidesIcon.svg';
import playIcon from './icons/play-timeline.svg';
import pauseIcon from './icons/pause-timeline.svg';
import iconRotate from './icons/icon_rotate.svg';
import iconMinimize from './icons/minimize.svg';
import iconSwitchSide from './icons/icon_switch_side.svg';
import iconMaximize from './icons/maximize.svg';
import iconMaximize2 from './icons/maximize2.svg';
import iconMaximize3 from './icons/maximize3.svg';
import iconClose from './icons/close.svg';
import iconSideBySide from './icons/icon_side_by_side.svg';
//import previewPlayButton from './icons/play_icon_fullscreen.svg';
import previewPlayButton from './icons/play-ui.svg';
import progressIndicatorIcon from './icons/progress_indicator.svg';


window.onload = async () => {
    let isExists    = false;
    let manifest    = {};
    const playerDiv = document.querySelector("#player-container");
    

    /* Paella felül írt függvényei */
    async function getManifestUrlFunction(repoUrl, videoId, config, player) {
        
        return playerDiv.dataset.manifest;
    }

    async function getManifestFileUrlFunction(manifestUrl, manifestFileName, config, player) {
      
        return playerDiv.dataset.manifest;
    }

    async function getLoadVideoManifestFunction(videoManifestUrl, config, player) {

        if (isExists) {
            return manifest;
        }

        const response = await fetch(videoManifestUrl);
        return response.json();
    }



    /* Paella lejátszó inicializálása */
    const initParams = {
        customPluginContext: [
            require.context("./plugins", true, /\.js/),
            getBasicPluginContext(),
            getSlidePluginContext(),
            getZoomPluginContext()
        ],
        configUrl: (typeof slideEditor !== "undefined" && slideEditor === true) ? "config/editor.json" : "config/config.json",
        getManifestUrl: getManifestUrlFunction,
        getManifestFileUrl: getManifestFileUrlFunction,
        loadVideoManifest: getLoadVideoManifestFunction,

        loadDictionaries: player => {

            addDictionary("hu", {
                "Disabled":          "Letíltva",
                "Volume":            "Hangerő",
                "Close video":       "Videó bezárása",
                "Toggle fullscreen": "Teljes képernyős mód váltás",
                "Video layout":      "Elrendezés",
                "Show slides":       "Diák megjelenítése",
                "Select captions":   "Felirat kiválasztása"
            });

            player.setLanguage(paella.config.defaultLanguage);
        }

    };

    class PaellaPlayer extends Paella {

        get version() {
            const player        = packageData.version;
            const coreLibrary   = super.version;
            const pluginModules = this.pluginModules.map(m => `${m.moduleName}: ${m.moduleVersion}`);
            return {
                player,
                coreLibrary,
                pluginModules
            };
        }
    }

    let paella = new PaellaPlayer("player-container", initParams);

    paella.bindEvent(Events.PLAYER_LOADED, async () => {
        if (typeof paella._videoManifest.frameList !== "undefined" && paella._videoManifest.frameList.length > 0 && paella.videoContainer.validContentIds[3]) {
            await paella.videoContainer.setLayout(paella.videoContainer.validContentIds[3]);
        } else {
            await paella.videoContainer.setLayout(paella.videoContainer.validContentIds[1]);
        }
    });

    try {

        await paella.loadManifest();
    
        await utils.loadStyle("paella-player.css");
    
        paella.addCustomPluginIcon("es.upv.paella.playPauseButton","play", playIcon);
        paella.addCustomPluginIcon("es.upv.paella.playPauseButton","pause", pauseIcon);
    
        // Customized icon tests
        // fullscreen 
        paella.addCustomPluginIcon("es.upv.paella.fullscreenButton", "fullscreenIcon", fullscreenIcon);
        paella.addCustomPluginIcon("es.upv.paella.fullscreenButton", "windowedIcon", windowedIcon);
    
        // volume
        paella.addCustomPluginIcon("es.upv.paella.volumeButtonPlugin", "volumeHighIcon", volumeHighIcon);
        paella.addCustomPluginIcon("es.upv.paella.volumeButtonPlugin", "volumeMidIcon", volumeMidIcon);
        paella.addCustomPluginIcon("es.upv.paella.volumeButtonPlugin", "volumeLowIcon", volumeLowIcon);
        paella.addCustomPluginIcon("es.upv.paella.volumeButtonPlugin", "volumeMuteIcon", volumeMuteIcon);
    
        paella.addCustomPluginIcon("es.upv.paella.Loader", "ProgressIndicatorIcon", progressIndicatorIcon);
    
        // quality selector
        // paella.addCustomPluginIcon("es.upv.paella.qualitySelector", "screenIcon", screenIcon);
    
        // playback rate
        // paella.addCustomPluginIcon("es.upv.paella.playbackRateButton", "screenIcon", screenIcon);
    
        // layout selector
        paella.addCustomPluginIcon("es.upv.paella.layoutSelector", "layoutIcon", layoutIcon);
    
        // audio selector
        paella.addCustomPluginIcon("es.upv.paella.audioSelector", "screenIcon", screenIcon);
    
        // download icon
        paella.addCustomPluginIcon("es.upv.paella.downloadsPlugin", "downloadIcon", downloadIcon);
    
        // find captions icon
        paella.addCustomPluginIcon("es.upv.paella.findCaptionsPlugin", "findCaptionsIcon", findCaptionsIcon);
    
        // captions icon
        paella.addCustomPluginIcon("es.upv.paella.captionsSelectorPlugin", "captionsIcon", captionsIcon);
    
        // slides icon
        paella.addCustomPluginIcon("es.upv.paella.frameControlButtonPlugin", "photoIcon", slidesIcon);
    
        // singel video icons
        paella.addCustomPluginIcon("es.upv.paella.singleVideo" , "iconSideBySide" , iconSideBySide);
    
        // dual video icons
        paella.addCustomPluginIcon("es.upv.paella.dualVideo" , "iconRotate",   iconRotate);
        paella.addCustomPluginIcon("es.upv.paella.dualVideo" , "iconMinimize", iconMinimize);
            
        paella.addCustomPluginIcon("es.upv.paella.dualVideo" , "iconMaximize",   iconMaximize);
        paella.addCustomPluginIcon("es.upv.paella.dualVideo" , "iconClose",      iconClose);
        paella.addCustomPluginIcon("es.upv.paella.dualVideo" , "iconSwitchSide", iconSwitchSide);
        paella.addCustomPluginIcon("es.upv.paella.dualVideo" , "iconSideBySide", iconSideBySide);
    
        paella.addCustomPluginIcon("es.upv.paella.dualVideoPiP" , "iconMaximize",    iconMaximize2);
        paella.addCustomPluginIcon("es.upv.paella.dualVideoPiP" , "iconClose",       iconClose);
        paella.addCustomPluginIcon("es.upv.paella.dualVideoPiP" , "iconSwitchSide" , iconSwitchSide);
        paella.addCustomPluginIcon("es.upv.paella.dualVideoPiP" , "iconSideBySide" , iconSideBySide);
    
        paella.addCustomPluginIcon("es.upv.paella.dualVideoSideBySide" , "iconMaximize",   iconMaximize);
        paella.addCustomPluginIcon("es.upv.paella.dualVideoSideBySide" , "iconClose",      iconClose);
        paella.addCustomPluginIcon("es.upv.paella.dualVideoSideBySide" , "iconSwitchSide", iconSwitchSide);
        paella.addCustomPluginIcon("es.upv.paella.dualVideoSideBySide" , "iconSideBySide", iconSideBySide);
    
        paella.addCustomPluginIcon("es.upv.paella.dualVideoDynamic" , "iconMaximize",   iconMaximize);
        paella.addCustomPluginIcon("es.upv.paella.dualVideoDynamic" , "iconClose",      iconClose);
        paella.addCustomPluginIcon("es.upv.paella.dualVideoDynamic" , "iconSwitchSide", iconSwitchSide);
        paella.addCustomPluginIcon("es.upv.paella.dualVideoDynamic" , "iconSideBySide", iconSideBySide);
    }
    catch (e) {
        console.error(e);
    }



    if( typeof slideEditor !== "undefined" && slideEditor === true ) {
        /* Változók */
        let unusedSlidesBox = document.getElementById("player-presentation-side-container");
        let usedSlidesBox   = document.getElementById("player-presentation-frames-container");
        let selected;
        
        /* Konstansok */
        const slides    = document.getElementsByClassName("player-presentation-slide");



        /* Drag-and-drop műveletek */
        for (let slide of slides) {
            slide.addEventListener("dragstart", function(e) {
                selected = e.target; 
                e.dataTransfer.setDragImage(new Image(), 0, 0);
            });
        }

        for (let div of [usedSlidesBox, unusedSlidesBox]) {
            div.addEventListener("dragover", function(e) { e.preventDefault(); });
        }

        playerDiv.addEventListener("dragover", function(e) {
            e.preventDefault();

            const playbarRect     = playerDiv.getBoundingClientRect();
            const mouseX          = e.clientX - playbarRect.left;
            const mouseY          = e.clientY - playbarRect.top;
            const containerSize   = paella.containerSize.w;
            const duration        = parseInt(paella.videoManifest.metadata.duration);
            const activeDuration  = new Date(((mouseX * duration) / containerSize) * 1000).toISOString().slice(11, 19);

            if (!document.querySelector("span.player-duration")) {
                let span         = document.createElement("span");
                span.textContent = activeDuration;
                span.className   = "player-duration";
                span.style.top   = `${mouseY + 20}px`;
                span.style.left  = `${mouseX + 20}px`;
                
                document.querySelector(".player-slide-editor").appendChild(span);
            } else {
                document.querySelector("span.player-duration").textContent = activeDuration;
                document.querySelector("span.player-duration").style.top   = `${mouseY + 20}px`;
                document.querySelector("span.player-duration").style.left  = `${mouseX + 20}px`;
            }
        });

        playerDiv.addEventListener("dragleave", function(e) { 
            removeDuration(); 
        });

        playerDiv.addEventListener("drop", function(e) {
            movingSlide(document.querySelector("span.player-duration").textContent);
            removeDuration();
        });

        usedSlidesBox.addEventListener("drop", function(e) {
            paella.videoContainer.currentTime().then((value) => {
                movingSlide(new Date(value * 1000).toISOString().slice(11, 19));
            }).catch((error) => {
                movingSlide("00:00:00");
            });
        });

        unusedSlidesBox.addEventListener("drop", function(e) {
            if (!usedSlidesBox.contains(selected)) return;

            selected.classList.remove("slide-frame-box");
            selected.removeChild(selected.lastElementChild);

            unusedSlidesBox.appendChild(selected);

            if (unusedSlidesBox.children.length > 1) {
                const sortedDivs = Array.from(unusedSlidesBox.children).sort((a, b) => parseInt(a.dataset.id) - parseInt(b.dataset.id));
                sortedDivs.forEach(div => unusedSlidesBox.appendChild(div));
            }

            generateNewPlayer();
        });



        /* Függvények */
        function movingSlide(time) {
            paella.pause();

            const id       = selected.dataset.id;
            let usedSlides = Array.from(document.getElementsByClassName("slide-frame-box"));

            if (usedSlides.includes(selected)) 
                usedSlides = usedSlides.filter(function(o) { return o !== selected });

            if (!selected.querySelector(".player-slide-frame-duration")) {
                selected.classList.add("slide-frame-box");

                let div         = document.createElement("div");
                div.className   = "player-slide-frame-duration";

                let hidden      = document.createElement("input");
                hidden.type     = "hidden";
                hidden.name     = "slides[id][]";
                hidden.value    = id;

                let input       = document.createElement("input");
                input.id        = id + "-time";
                input.className = "input-time";
                input.type      = "text";
                input.name      = "slides[duration][]";
                input.value     = "00:00:00";

                div.appendChild(hidden);
                div.appendChild(input);
                selected.appendChild(div);
            }

            document.getElementById(id + "-time").value = time;

            const inputTime   = document.getElementsByClassName("input-time");
            const maskOptions = { mask: "00:00:00" };
            for (let t of inputTime) {
                let mask = IMask(t, maskOptions);
            }

            var index = usedSlides.findIndex(function(e) {
                return durationCalculation((e.querySelector(".player-slide-frame-duration input.input-time").value).split(":")) > durationCalculation(time.split(":"));
            });

            if (index === -1) {
                usedSlides.push(selected);
            } else {
                usedSlides.splice(index, 0, selected);
            }

            usedSlides.forEach(function(element) {
                usedSlidesBox.appendChild(element);
            });

            generateNewPlayer();
        }

        /* Manifest fájl generálása */
        function generateManifestData(paella, frames) {
            let newFrames  = [];
            let newSources = [];

            for (let frame of frames.children) {
                let id       = frame.dataset.id;
                let duration = durationCalculation(frame.firstElementChild.lastElementChild.value.split(":"));
                let url      = frame.style.backgroundImage.split('"')[1];
                
                newFrames.push({
                    "id": id,
                    "mimetype": "image/jpeg",
                    "thumb": url,
                    "time": duration,
                    "url": url
                });

                newSources.push({
                    "time": duration,
                    "src": url
                });
            }

            if (frames.children.length === 0) {
                newSources.push({
                    "time": 0,
                    "src": ""
                });
            }

            manifest = paella._videoManifest;
            manifest.frameList = newFrames;
            manifest.streams[0] = {
                "sources": {
                    "image": [
                        {
                            "mimetype": "image/jpeg",
                            "frames": newSources,
                            "count": frames.children.length,
                            "duration": paella.streams.streams[0].sources.image[0].duration,
                            "res": paella.streams.streams[0].sources.image[0].res
                        },
                        {
                            "mimetype": "image/jpeg",
                            "frames": newSources,
                            "count": frames.children.length,
                            "duration": paella.streams.streams[0].sources.image[1].duration,
                            "res": paella.streams.streams[0].sources.image[1].res
                        }
                    ]
                },
                "content": paella.streams.streams[0].content
            };
        }



        /* Kiegészítő függvények */
        function durationCalculation(elements) {
            return (parseInt(elements[0]) * 60) + (parseInt(elements[1]) * 60) + (parseInt(elements[2]));
        }

        function removeDuration() {
            if (document.querySelector("span.player-duration")) 
                document.querySelector("span.player-duration").remove();
        }



        /* Aszinkron függvények */
        async function generateNewPlayer() {
            generateManifestData(paella, usedSlidesBox);
            isExists = true;

            if (playerDiv)
                playerDiv.innerHTML = "";

            await paella.reload();
            paella.play();

            if (usedSlidesBox.children.length > 0) {
                await paella.videoContainer.setLayout(paella.videoContainer.validContentIds[3]);
            } else {
                await paella.videoContainer.setLayout(paella.videoContainer.validContentIds[1]);
            }
        }



        /* Eseményfigyelők */
        usedSlidesBox.addEventListener("change", function(e) {
            if (e.target.className.toLowerCase() === "input-time") {
                document.getElementById(e.target.id).value = e.target.value;
                generateNewPlayer();
            }
        });

        for (let slide of slides) {
            slide.addEventListener("dblclick", async function (e) {
                if(slide.hasChildNodes(".player-slide-frame-duration")) {
                    paella.videoContainer.setCurrentTime(durationCalculation(slide.querySelector(".player-slide-frame-duration").lastElementChild.value.split(":")));
                }
            });
        }
    }
}